<template>
  <div
    class="rounded-lg border p-4 mb-3 transition-colors"
    :class="selected ? 'border-green-500 bg-green-50' : 'border-amber-300 bg-amber-50'"
  >
    <div class="flex justify-between items-center gap-2" :class="{ 'mb-2': $slots.default }">
      <span class="text-sm font-semibold text-gray-brand-800 tracking-tight">
        {{ label }}
      </span>
      <span
        v-if="selected"
        class="inline-flex items-center flex-none px-2 py-0.5 rounded-full text-xs font-medium bg-green-100 text-green-800"
      >
        <CheckCircleIcon class="h-3.5 w-3.5 mr-1" />
        {{ selectedLabel }}
      </span>
      <slot v-else name="action">
        <span
          class="inline-flex items-center flex-none px-2 py-0.5 rounded-full text-xs font-medium bg-amber-100 text-amber-900"
        >
          {{ requiredLabel }}
        </span>
      </slot>
    </div>
    <slot />
  </div>
</template>

<script>
import { CheckCircleIcon } from '@heroicons/vue/solid'

export default {
  name: 'RequiredFieldFrame',
  components: { CheckCircleIcon },
  props: {
    label: { type: String, required: true },
    selected: { type: Boolean, default: false },
    requiredLabel: { type: String, default: 'Required' },
    selectedLabel: { type: String, default: 'Selected' }
  }
}
</script>
